var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClicktoseemoreskills(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 28C14.2089 28 16 26.2097 16 24C16 21.7903 14.2089 20 12 20C9.79113 20 8 21.7903 8 24C8 26.2097 9.79113 28 12 28ZM24 28C26.2089 28 28 26.2097 28 24C28 21.7903 26.2089 20 24 20C21.7911 20 20 21.7903 20 24C20 26.2097 21.7911 28 24 28ZM24 22C25.1045 22 26 22.8951 26 24C26 25.1049 25.1045 26 24 26C22.8955 26 22 25.1049 22 24C22 22.8951 22.8955 22 24 22ZM14 24C14 22.8951 13.1045 22 12 22C10.8955 22 10 22.8951 10 24C10 25.1049 10.8955 26 12 26C13.1045 26 14 25.1049 14 24ZM38 24C38 22.8951 37.1045 22 36 22C34.8955 22 34 22.8951 34 24C34 25.1049 34.8955 26 36 26C37.1045 26 38 25.1049 38 24ZM36 28C38.2089 28 40 26.2097 40 24C40 21.7903 38.2089 20 36 20C33.7911 20 32 21.7903 32 24C32 26.2097 33.7911 28 36 28Z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClicktoseemoreskills);
export default __webpack_public_path__ + "static/media/Click to see more skills.c08f7baa0a8bf7b9fe50e2e8ebe17a1c.svg";
export { ForwardRef as ReactComponent };